var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex max-width"},[_c('div',{staticClass:"flex-grow-1"},[_vm._t("default")],2),_c('div',[_c('TutorialButton',{attrs:{"tutorialName":_vm.dialogName}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }